import { ClearOutlined } from '@mui/icons-material';
import { IconButton, InputAdornment, MenuItem, TextField } from '@mui/material';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  label: string;
  disabled?: boolean;
  options: { label: string; value: string | number }[];
  tooltip?: string;
  rules?: RegisterOptions; // Accepts validation rules
  required?: boolean;
  defaultValue?: any;
  clearOption?: boolean;
};

const VNSelect = ({
  name,
  label,
  options,
  disabled = false,
  tooltip = '',
  defaultValue = '',
  required = false,
  rules = {},
  clearOption = false,
}: Props) => {
  const { control, setValue } = useFormContext();

  return (
    <div className="vn-select">
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{
          ...(rules || {}),
          ...(required && { required: `${label} is required` }),
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            select
            label={`${label}${required ? ' *' : ''}`}
            size="small"
            error={!!error}
            helperText={error?.message || tooltip}
            disabled={disabled}
            {...field}
            SelectProps={{
              MenuProps: {
                disableScrollLock: true,
                sx: { maxHeight: '50%', maxWidth: '50%' },
              },
            }}
            InputProps={{
              endAdornment:
                clearOption && field.value ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent select dropdown from opening
                        setValue(name, '');
                      }}
                      edge="end"
                      sx={{ mr: 1 }}
                    >
                      <ClearOutlined fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </div>
  );
};

export default VNSelect;
